module.exports = __webpack_public_path__ + "static/media/logothermomix.a587d0ef.svg";